<div class="ui-skeleton-loader" [ngClass]="getLoaderClasses()"></div>